"use client"

import { useState } from "react"
import Header from "../../components/protected/Header"
import ReactPaginate from "react-paginate"
import Footer from "../../components/footer"
import Texts from "../../components/protected/texts/Texts"
import { Link } from "react-router-dom"
import { useTranslations } from "../../translations"
import LanguageSelector from "../../components/LanguageSelector"
import { useSchoolRole } from "../../hooks/useSchoolRole"
import { distributeToSection } from "../../components/utils/distributeSection"

const ListText = ({ values }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6)
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1)
  }

  const currentItems = values.data.slice(indexOfFirstItem, indexOfLastItem)
  const { t } = useTranslations()
  const { role } = useSchoolRole()
  const isTeacher = role === "maestro"
  const handleDistribute = (text) => distributeToSection(text, "text", t)

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div>
            <h1 className="dashboard-title mb-1">{values.title}</h1>
            <p className="text-muted">{t("manageTexts")}</p>
          </div>
        </div>

        <div className="modern-card" style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}>
          <div className="d-flex justify-content-between align-items-center mb-4 px-1">
            <h4 className="fw-bold color-plum mb-0">{t("texts")}</h4>
            <Link className="btn-manual-modern text-decoration-none py-2 px-4 mt-0" to={"/actions/create-text"}>
              + {t("create")}
            </Link>
          </div>
          <div className="table-responsive">
            <table className="table modern-table">
              <thead>
                <tr>
                  <th scope="col" className="text-center" style={{ width: '80px' }}>#</th>
                  <th scope="col">{t("texts")}</th>
                  <th scope="col" className="text-center">{t("numberOfQuestions")}</th>
                  <th scope="col" className="text-center">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && (
                  <Texts
                    currentItems={currentItems}
                    itemOffset={indexOfFirstItem}
                    handleDelete={values.handleDelete}
                    isTeacher={isTeacher}
                    onDistribute={handleDistribute}
                  />
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <ReactPaginate
              onPageChange={paginate}
              pageCount={Math.ceil(values.data.length / itemsPerPage)}
              previousLabel={t("previous")}
              nextLabel={t("next")}
              containerClassName={"modern-pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
            />
          </div>
        </div>
        <Footer logged={values.logged} />
      </main>

      <style>{`
        .color-plum { color: var(--plum-bg); }
      `}</style>
    </div>
  )
}

export default ListText
